import { render, staticRenderFns } from "./SingleEmployee.vue?vue&type=template&id=7f4f5654&"
import script from "./SingleEmployee.vue?vue&type=script&lang=js&"
export * from "./SingleEmployee.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports